import validate from "/app/node_modules/.pnpm/nuxt@3.20.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compile_f3e1875dcb330f8c09d4b408e89c27d4/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.20.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compile_f3e1875dcb330f8c09d4b408e89c27d4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}